import OapDsfAppWrapper from './code/Scripts/components/OapDsfAppWrapper/OapDsfAppWrapper.vue';

export default {
  components: {
    OapDsfAppWrapper,
  },
};
